export default "__VITE_ASSET__f0a62ea1__"